import { render } from "./SelectionChips.vue?vue&type=template&id=27f35cac&scoped=true"
import script from "./SelectionChips.vue?vue&type=script&lang=js"
export * from "./SelectionChips.vue?vue&type=script&lang=js"

import "./SelectionChips.vue?vue&type=style&index=0&id=27f35cac&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f35cac"]])

export default __exports__